/**
 * @fileoverview POST handler for the "/companies/:company_id/email_self_serve/:app_group_id/sending_domain/:domain_id/partner_tracking_domain" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdEmailSelfServeSendingDomainDomainIdPartnerTrackingDomainCacheKeys } from "./constants";
import type { PostPartnerTrackingDomainProps, PostPartnerTrackingDomainResult } from "./types";

export const postPartnerTrackingDomain = reactQueryMutationAdapter(
  companiesCompanyIdEmailSelfServeSendingDomainDomainIdPartnerTrackingDomainCacheKeys,
  (props: PostPartnerTrackingDomainProps): Promise<PostPartnerTrackingDomainResult> => {
    const { companyId, appGroupId, parentDomainId, ...requestBody } = props;

    return fetch(
      `/companies/${companyId}/email_self_serve/${appGroupId}/sending_domain/${parentDomainId}/partner_tracking_domain`,
      "POST",
      requestBody,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
